/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type GroupOrderPostOrderQueryVariables = Exact<{
  orderId: string | number;
}>;

export type GroupOrderPostOrderQuery = {
  readonly order: {
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly multipartyDetails: { readonly displayName: string } | null;
    readonly lineItems: ReadonlyArray<{
      readonly orderParticipant: { readonly isMe: boolean } | null;
    }>;
    readonly restaurant: { readonly id: string; readonly isOutpost: boolean };
  };
};

export const GroupOrderPostOrderDocument = gql`
  query GroupOrderPostOrder($orderId: ID!) {
    order(orderId: $orderId) {
      id
      orderType
      orderState
      multipartyDetails {
        displayName
      }
      lineItems {
        orderParticipant {
          isMe
        }
      }
      restaurant {
        id
        isOutpost
      }
    }
  }
`;

export function useGroupOrderPostOrderQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderPostOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderPostOrderQuery, GroupOrderPostOrderQueryVariables>({
    query: GroupOrderPostOrderDocument,
    ...options,
  });
}
